export enum EmploymentType {
  FullTime = 'full_time',
  PartTime = 'part_time',
  Marginal = 'marginal',
  Apprenticeship = 'apprenticeship',
  /** Honorararzt — Docia only. */
  FreelanceLocum = 'freelance_locum',
  /** Vertretung / Zeitarbeit — Docia only. */
  Temporary = 'temporary',
}

/** Values only ever set by the Docia funnel; kept off Pflegia/Praxia selects. */
export const DOCIA_ONLY_EMPLOYMENT_TYPES = [EmploymentType.FreelanceLocum, EmploymentType.Temporary];

/** Values the Docia funnel never sets (mapDociaEmploymentTypes only accepts FullTime/PartTime/FreelanceLocum/Temporary); kept off Docia selects. */
export const NON_DOCIA_EMPLOYMENT_TYPES = [EmploymentType.Marginal, EmploymentType.Apprenticeship];

export const EMPLOYMENT_TYPES_WITH_HOURS = [EmploymentType.PartTime, EmploymentType.Marginal];

export const EMPLOYMENT_NAME_BY_TYPE: Record<EmploymentType, string> = {
  [EmploymentType.FullTime]: 'Vollzeit',
  [EmploymentType.PartTime]: 'Teilzeit',
  [EmploymentType.Marginal]: 'Geringfügig',
  [EmploymentType.Apprenticeship]: 'Ausbildung',
  [EmploymentType.FreelanceLocum]: 'Honorararzt',
  [EmploymentType.Temporary]: 'Vertretung',
};

export const WORKING_HOURS_DEFAULT = 20;
export const WORKING_HOURS_MAX = 40;
export const WORKING_HOURS_MIN = 5;

export const WORKING_HOURS_BY_TYPE: Record<EmploymentType, number> = {
  [EmploymentType.FullTime]: WORKING_HOURS_MAX,
  [EmploymentType.PartTime]: 25,
  [EmploymentType.Marginal]: 10,
  [EmploymentType.Apprenticeship]: 10,
  [EmploymentType.FreelanceLocum]: WORKING_HOURS_MAX,
  [EmploymentType.Temporary]: WORKING_HOURS_MAX,
};

export enum PermanentOrTemporaryJob {
  Permanent = 'permanent',
  Temporary = 'temporary',
  Both = 'both',
}
